<ng-container *transloco="let t">
  <div class="flex max-h-[70vh] w-[50rem] flex-col">
    <div class="table-container flex-1">
      <mat-table [dataSource]="dataSource" class="table-sm table-striped-two table-hover mt-4 table shadow-sm">
        <ng-container matColumnDef="account">
          <mat-header-cell *matHeaderCellDef>{{ t("common.account") }}</mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.accountName && item.accountName.length > 0 ? item.accountName : item.accountId }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="marketplace">
          <mat-header-cell *matHeaderCellDef class="table-header justify-center text-center">
            {{ t("common.marketplace") }}
          </mat-header-cell>
          <mat-cell *matCellDef="let item" class="justify-center">
            <IBadge [label]="item.marketplace" color="gray" size="sm" />
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="adSpendFee">
          <mat-header-cell *matHeaderCellDef class="table-header justify-end pr-0 text-center">
            <span class="w-full">{{ t("invoice-details-modal.ad_spend_fee") }}</span>
            <button class="btn" (click)="downloadFile()" matTooltip="{{ t('common.export_as_csv') }}">
              <span class="icon-[lucide--download]"></span>
            </button>
          </mat-header-cell>
          <mat-cell *matCellDef="let item" class="justify-center">{{ formatAmount(item.adSpendFee) }}</mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>

    <div class="mt-4 flex justify-end">
      <IButton [label]="t('common.close')" color="white" (onClick)="close()" />
    </div>
  </div>
</ng-container>
